import { base, checktoken } from "../constants/urls";

export const checkToken = async (token) => {
  if (!token) {
    console.warn("checkToken: No token provided in state yet.");
    return false;
  }

  try {
    const response = await fetch(`${base}${checktoken}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // 1. If the server explicitly rejects it with a 401/403 HTTP status
    if (!response.ok && response.status !== 200) {
      console.warn(`checkToken: Server returned HTTP ${response.status}`);
      return false;
    }

    const result = await response.json();

    // 2. Safely check the specific success payload you provided
    // We check for statusCode === 0 OR data === true
    if (result.statusCode === 0 || String(result.statusCode) === "0" || result.data === true) {
      return true;
    }

    // 3. If it hits this point, it means it got the Failure payload (StatusCode: 2)
    console.warn("checkToken: Token invalid. API Message:", result.Message || result.message);
    return false;

  } catch (error) {
    console.error("checkToken: Network or parsing error", error);
    return false;
  }
};